<template>
  <div class="editCube">
    <div>{{title}} <button class="editBtn" @click="setEdit"></button></div>
    <div class="opts" v-if="data"  :style="[col ? {flexDirection: 'column'} : {}]">
      <div v-for="(opt, o) in defaultValue" :key="`opt-${o}`" class="opt" :style="[w ? {width: w} : {}]">{{opt}}</div>
    </div>
    <template v-if="edit">
      <div class="dialogBg">
        <div class="cube" :label="title">
        <div class="closeBtn" @click="edit=false"></div>
        <div class="griddate">
          <div v-for="(dt, d) in datainput" :key="`date-${d}`" :class="(d%2)===0?'left':'right'">
            <input type="text" v-model="datainput[d]">
          </div>
          <button class="more" @click="datainput=datainput.concat(...Array(10).fill(null))"></button>
        </div>
        <div class="btns" v-if="edit">
          <button class="cancel" @click="edit=false">取消</button>
          <button class="confirm" @click="$emit('save', datainput.filter(e => e))">儲存</button>
        </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: ['title', 'defaultValue', 'w', 'col'],
  data () {
    return {
      edit: false,
      data: [],
      datainput: Array(33).fill(null)
    }
  },
  watch: {
    defaultValue: {
      immediate: true,
      handler () {
        this.data = this.defaultValue
        this.edit = false
      }
    }
  },
  async mounted () {
    this.datainput = Array(33).fill(null)
  },
  methods: {
    setEdit () {
      this.datainput = Array(33).fill(null)
      this.defaultValue.forEach((e, i) => {
        this.datainput[i] = e
      })
      this.edit = true
    }
  }

}
</script>

<style lang="scss" scoped>
.more {
  border-right: 1px solid var(--color-border);
  border-bottom: 1px solid var(--color-border);
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  gap: 10px;
  &::before {
    content: '';
    display: inline;
    width: 30px;
    height: 30px;
    background-color: var(--color-border);
    mask-image: url(/svg/btn/plusSqr.svg);
    mask-position: center;
    mask-repeat: no-repeat;
    mask-size: 24px;
  }
  &::after {
    content: '新增更多欄位';
    width: '4em';
    color: var(--color-border);
    letter-spacing: 3px;
    font-size: 20px;
  }
  &:hover {
    &::before {
      background-color: var(--color-checked);
    }
    &::after {
      color: var(--color-checked);
    }
  }
}
.griddate {
  padding: 14px 15px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  max-height: 379px;
  overflow-y: auto;
  &>.left {
    border: 1px solid var(--color-border);
    border-top: none;
    padding: 2px;
    box-sizing: border-box;
  }
  &>.right {
    border: 1px solid var(--color-border);
    border-left: none;
    border-top: none;
    padding: 2px;
    box-sizing: border-box;
  }
  &>:nth-child(1),&>:nth-child(2) {
    border-top: 1px solid var(--color-border);
  }
  &>div>input {
    height: 38px;
    border: none;
    width: calc(100% - 2px);
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    letter-spacing: 0.1em;
    color: var(--color-pri);
    text-align: center;

  }
}
.closeBtn {
  position: absolute;
  top: 9px;
  right: 9px;
  width: 30px;
  height: 30.28px;
  background-color: #FFFFFF;
  mask-image: url(./close.svg);
  mask-size: contain;
  border: none;
  mask-repeat: no-repeat;
  box-sizing: border-box;
}
.cube {
  position: relative;
  width: 711px;
  height: 515px;
  background-color: #FFFFFF;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  margin-top: 96px;
  &::before {
    content: attr(label);
    display: inline-flex;
    width: 100%;
    height: 55px;
    font-family: 'Noto Sans TC';
    font-style: normal;
    font-weight: 400;
    font-size: 24px;
    letter-spacing: 0.1em;
    background-color: var(--color-pri);
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px 5px 0 0;
  }
}
.dialogBg {
  position: fixed;
  backdrop-filter: blur(3px);
  background-color: #99999933;
  top: 90px;
  left: 70px;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: flex-start;
  padding-top: 50px;
  justify-content: center;
  z-index: 20;
  overflow-y: auto;
}
.opts {
  margin-block: 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}
.opt {
min-width: 100px;
width: fit-content;
padding-inline: .5em;
height: 55px;
border: 1.5px solid var(--color-pri);
box-sizing: border-box;
border-radius: 5px;
display: flex;
align-items: center;
justify-content: center;
font-family: 'Roboto';
font-style: normal;
font-weight: 400;
font-size: 20px;
line-height: 23px;
letter-spacing: 0.1em;
white-space: nowrap;
}
.editCube {
  margin: 0;
  margin-bottom: 20px;
  text-align: start;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 25px;
  line-height: 29px;
  letter-spacing: 0.1em;
  color: var(--color-pri);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 9px;
  textarea, p {
    margin: 0;
    height: 200px;
    text-align: start;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 67px;
    letter-spacing: 0.1em;
    color: var(--color-letter);
    width: -webkit-fill-available;
    input {
      width: 100px;
      height: 40px;
      box-sizing: border-box;
      border-radius: 3px;
      border: 1px solid var(--color-border);
      margin-inline: 9px;
      text-align: center;
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 900;
      font-size: 18px;
      text-align: center;
      letter-spacing: 0.1em;
      color: var(--color-confirm);
    }
  }
  &>div:nth-child(1) {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    &>button {
      margin-left: auto;
      width: 35px;
      height: 35px;
      background-color: var(--color-pri);
      background-image: url(./pen.svg);
      background-position: center;
      background-repeat: no-repeat;
      border: none;
      border-radius: 50%;
      background-size: 19px;
    }
  }
}
.btns{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
  gap: 28px;
  width: 100%;
  button {
    &:disabled {
      filter: contrast(.5);
    }
    border: none;
    width: 100px;
    height: 35px;
    border-radius: 20px;
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    &.confirm {
      background: #E37878;
    }
    &.cancel {
      background: #B8B8B8;
    }
  }
}

</style>
